

import React, { useContext, useEffect} from 'react'
import  Language  from '../Context/Language'
import {
  useLocation
  } from "react-router-dom";

export default function Loading() {
  const dataLang = useContext(Language)
   const location = useLocation()

  return (
    <div className='LoadingPageDiv'>
      <div className='LoadingTextAnimate'>
      {dataLang[dataLang.lang].Loading}
      </div>
    </div>
    
  )
}
